import React from 'react';
import {
  FDBox, FDTable, FDStack, FDPagination,
} from '@facet-wealth/design';
import PlannerTransitionTableHead
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableContent/PlannerTransitionTableHead';
import PlannerTransitionTableBody
  from 'Views/Page/Content/Templates/PlannerTransitionHouseholdTemplate/Content/PlannerTransitionTableContent/PlannerTransitionTableBody';
import PropTypes from 'prop-types';

const PlannerTransitionTableContent = ({
  plannerTransitionCollection,
  onPaginationChange,
  currentPageNumber,
  loading,
  loadingError,
  hasNextPage,
  loadingPrevOrNextPage,
}) => {
  return (
    <FDBox margin={400}>
      <FDTable size={'sm'}>
        <PlannerTransitionTableHead
          plannerTransitionCollection={plannerTransitionCollection}
        />
        <PlannerTransitionTableBody
          plannerTransitionCollection={plannerTransitionCollection}
          loading={loading}
          loadingError={loadingError}
        />
      </FDTable>
      <FDStack direction={'column'}>
        <FDPagination
          hasNextPage={hasNextPage}
          alignSelf={'center'}
          onChange={onPaginationChange}
          page={currentPageNumber}
          loading={loadingPrevOrNextPage}
        />
      </FDStack>
    </FDBox>
  );
};

PlannerTransitionTableContent.defaultProps = {
  loadingError: false,
  loading: false,
  hasNextPage: false,
  loadingPrevOrNextPage: false,
};

PlannerTransitionTableContent.propTypes = {
  plannerTransitionCollection: PropTypes.object.isRequired,
  currentPageNumber: PropTypes.number.isRequired,
  onPaginationChange: PropTypes.func.isRequired,
  hasNextPage: PropTypes.bool,
  loadingError: PropTypes.bool,
  loading: PropTypes.bool,
  loadingPrevOrNextPage: PropTypes.bool,
};

export default PlannerTransitionTableContent;
